module.exports = __webpack_public_path__ + "static/media/prototype-illustration.6696226d.svg";